let privatePrefix = '';
export function configurePrivateBuildingAssets(prefix: string): void {
  if (!/^\/api\/v2\/building-studio-test\/[A-Za-z0-9_-]{43}\/$/.test(prefix))
    throw new Error('Invalid private asset scope.');
  privatePrefix = prefix;
}
export function buildingAssetURL(asset: string): string {
  return privatePrefix && /^\/api\/v2\/building-assets\/[a-f0-9]{64}$/.test(asset)
    ? privatePrefix + asset.slice('/api/v2/'.length)
    : asset;
}
export function isCustomBuildingAsset(asset: string): boolean {
  return /^\/api\/v2\/building-assets\/[a-f0-9]{64}$/.test(asset);
}
